module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Rose_10.72895b55.png";